import React from "react";
import { useLocation } from "react-router-dom";
import { Calculator, Phone, FileSignature, Newspaper, Cigarette, Wine, Coffee } from "lucide-react";
import POSNegozio from "./POSNegozio";

// Configurazione per modalità rapide
const MODE_CONFIG = {
  tabacchi: {
    label: "Tabacchi",
    color: "#1F2937",
    icon: Cigarette,
    extras: [
      { id: "ricarica", label: "Ricarica tel.", icon: Phone, vat: 22 },
      { id: "bollo", label: "Marca da bollo", icon: FileSignature, vat: 22 },
      { id: "lotto", label: "Lotto/Gratta", icon: Calculator, vat: 0 },
    ],
  },
  edicola: {
    label: "Edicola",
    color: "#7C3AED",
    icon: Newspaper,
    extras: [
      { id: "giornale", label: "Quotidiano", icon: Newspaper, vat: 4 },
      { id: "rivista", label: "Rivista", icon: Newspaper, vat: 4 },
      { id: "bolletta", label: "Bolletta", icon: FileSignature, vat: 22 },
      { id: "ricarica", label: "Ricarica tel.", icon: Phone, vat: 22 },
    ],
  },
  enoteca: {
    label: "Enoteca",
    color: "#7F1D1D",
    icon: Wine,
    extras: [],
  },
  bar: {
    label: "Bar / Tavola calda",
    color: "#7C3AED",
    icon: Coffee,
    extras: [],
  },
};

// Sconto enoteca automatico per quantità bottiglie
const enotecaDiscount = (count) => (count >= 12 ? 15 : count >= 6 ? 10 : count >= 3 ? 5 : 0);

export default function POSRapido() {
  const loc = useLocation();
  const mode = loc.pathname.split("/").pop() || "tabacchi";
  const conf = MODE_CONFIG[mode] || MODE_CONFIG.tabacchi;
  const ModeIcon = conf.icon;

  return (
    <POSNegozio
      key={mode}
      mode={mode}
      title={`Velta One · ${conf.label}`}
      testidPrefix="rapido"
      extras={conf.extras}
      autoQtyDiscount={mode === "enoteca" ? enotecaDiscount : null}
      headerExtra={<ModeIcon className="w-5 h-5" style={{ color: conf.color }} />}
    />
  );
}
